import { ReactNode, CSSProperties } from 'react';
import cn from 'classnames';

interface GridItemProps {
  children: ReactNode;
  className?: string;
}

const AutoGridItem = (style: CSSProperties) => {
  const GridItem: React.FC<GridItemProps> = ({ children, className }) => {
    return (
      <li className={cn('auto-grid__item', className)} style={style}>
        {children}
      </li>
    );
  };

  return GridItem;
};

AutoGridItem.displayName = 'AutoGridItem';

export default AutoGridItem;
